import { forwardRef } from 'react';

import type { DateTimeFieldProps } from '..';
import type { PickerValidDate } from '../..';
import { FormControlWrapper } from '../../../form-control-wrapper';
import { OutlinedInput } from '../../../outlined-input';
import { type TextFieldProps } from '../../../text-field';
import { getDateInputFieldProps } from '../../utils/get-date-input-field-props';

// Props passed to textfield slot is based off TextFieldProps
type DateTimeInputFieldProps = TextFieldProps & {
  ownerState: DateTimeFieldProps<PickerValidDate, false>;
};

export const DateTimeInputField = forwardRef<
  HTMLDivElement,
  DateTimeInputFieldProps
>((props: DateTimeInputFieldProps, ref) => {
  const { formControlWrapperProps, outlinedInputProps } =
    getDateInputFieldProps(props);

  const {
    FormHelperTextProps,
    InputLabelProps,
    ...otherFormControlWrapperProps
  } = formControlWrapperProps;

  return (
    <FormControlWrapper
      ref={ref}
      formHelperTextProps={FormHelperTextProps}
      formLabelProps={InputLabelProps}
      {...otherFormControlWrapperProps}
    >
      <OutlinedInput {...outlinedInputProps} />
    </FormControlWrapper>
  );
});
